import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'INVIT_FOURN',
  title: 'Come invitare i miei fornitori?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Invitare i vostri fornitori/ subappaltatori vi permetterà di avere accesso ai loro documenti sulla piattaforma ogni volta che ne avete bisogno.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Vai alla scheda «Fornitori»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_FOURN/IT_INVIT_FOURN_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Clicca sul pulsante «Aggiungere un fornitore» in alto a destra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_FOURN/IT_INVIT_FOURN_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Se appare nell\'elenco, un semplice clic su di esso lo aggiunge alla lista dei fornitori.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_FOURN/IT_INVIT_FOURN_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Se non riesci a trovare il tuo fornitore, potrebbe non aderire alla piattaforma. Quindi, compilate il modulo d\'invito e convalida un invito.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INVIT_FOURN/IT_INVIT_FOURN_4.png`
  }]
};
